import{
  FETCH_EVENTS_DATA, EVENTS_DATA_REQUEST
} from '../constants/events'

const initState = {
  data    : null,
  fetching: true,
  limit    : {
    data    : null,
    fetching: true
  },
  info    : {
    data    : null,
    fetching: true
  },
  page    : {
    data    : null,
    fetching: true
  },
  participation:{
    fetching: false,
    alerte : null
  },
  search:{
    datasearch    : null,
    fetchingsearch: true
  },
  download:{
    datadw    : null,
    fetchingdw: true
  },
  assoc:{
    datassoc    : null,
    fetchingassoc: true
  },
  document:{
    datadoc    : null,
    fetchingdoc: true
  }
}

export default function eventsReducer(state = initState, action) {
  switch (action.type) {
    case EVENTS_DATA_REQUEST:
      return {
        ...state,
        ...action.payload
      }
    case FETCH_EVENTS_DATA:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/events.js